import {
    UPDATE_ORDERS_TABLE_ROW_FAILURE,
    UPDATE_ORDERS_TABLE_ROW_REQUEST,
    UPDATE_ORDERS_TABLE_ROW_SUCCESS
} from "../orders/constants";

const name = 'layout';

export const LAYOUT_SIDEBAR_OPEN = `${name}/LAYOUT_SIDEBAR_OPEN`;
export const LAYOUT_SIDEBAR_CLOSE = `${name}/LAYOUT_SIDEBAR_CLOSE`;
export const LAYOUT_MOUSE_OVER_OPENED_SIDEBAR = `${name}/LAYOUT_MOUSE_OVER_OPENED_SIDEBAR`;
export const LAYOUT_MOUSE_LEAVE_OPENED_SIDEBAR = `${name}/LAYOUT_MOUSE_LEAVE_OPENED_SIDEBAR`;
export const TOGGLE_SUB_MENU = `${name}/TOGGLE_SUB_MENU`;

export const LAYOUT_PRELOADER_OPEN = `${name}/LAYOUT_PRELOADER_OPEN`;
export const LAYOUT_PRELOADER_CLOSE = `${name}/LAYOUT_PRELOADER_CLOSE`;

// export const MODAL_WINDOW_ADD = `${name}/MODAL_WINDOW_ADD`;
export const MODAL_WINDOW_CLOSE = `${name}/MODAL_WINDOW_CLOSE`;

export const SOCKET_MODAL_SHOW = `${name}/SOCKET_MODAL_SHOW`;
export const SOCKET_MODAL_CLOSE = `${name}/SOCKET_MODAL_CLOSE`;

export const TOASTER_DISPATCH = `${name}/TOASTER_DISPATCH`;

export const LAYOUT_MOUSE_OVER_SIDEBAR = `${name}/LAYOUT_MOUSE_OVER_SIDEBAR`;
export const LAYOUT_MOUSE_LEAVE_SIDEBAR = `${name}/LAYOUT_MOUSE_LEAVE_SIDEBAR`;

export const UPDATE_COUNTERS = `${name}/UPDATE_COUNTERS`;
export const UPDATE_CHAT_COUNTERS = `${name}/UPDATE_CHAT_COUNTERS`;

export const MARK_AS_READ_NOTIFICATIONS_REQUEST = `${name}/MARK_AS_READ_NOTIFICATIONS_REQUEST`;
export const MARK_AS_READ_NOTIFICATIONS_SUCCESS = `${name}/MARK_AS_READ_NOTIFICATIONS_SUCCESS`;
export const MARK_AS_READ_NOTIFICATIONS_FAILURE = `${name}/MARK_AS_READ_NOTIFICATIONS_FAILURE`;

export const UPDATE_NOTIFICATIONS_LIST = `${name}/UPDATE_NOTIFICATIONS_LIST`;

export default name;
